import React from 'react';
import * as Sentry from '@sentry/browser';
import { hydrate, render } from 'react-dom';
import { StoreProvider } from 'redux-react-hook';
import I18nLoader from 'containers/I18nLoader';
import Config from 'config';
import buildStore from './store';

import { bootstrap } from './store/modules/app/actions';

import App from 'containers/App';

import './index.css';

if (Config.sentry.dsn) {
  Sentry.init({ dsn:  Config.sentry.dsn });
}

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<Root />, rootElement);
} else {
  render(<Root />, rootElement);
}

const initialState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;

function Root() {
  const store = buildStore(initialState);
  store.dispatch(bootstrap());

  window.snapSaveState = () => ({
    __PRELOADED_STATE__: store.getState(),
  });

  return (
    <StoreProvider value={store}>
      <I18nLoader>
        <App />
      </I18nLoader>
    </StoreProvider>
  );
}